import React from "react";
import { Field, formValueSelector, reduxForm } from "redux-form";
import validate from "./validate";
import { CNPJ, CPF, PHONE } from "components/NumberFormat";
import Input from "components/ReduxForm/Input";
import { useSelector } from "react-redux";
import { Spinner } from "reactstrap";
import renderCheckBoxField from "shared/components/form/CheckBox";
import renderDatePickerField from "shared/components/form/DatePicker";
import ls from "Localization";

const FormTwo = props => {
	const {
		handleSubmit,
		pristine,
		submitting,
		previousPage,
		onFormTwoSubmit,
		change
	} = props;

	const state = useSelector(state => state);

	const selector = formValueSelector("certificate_emission");

	const loading = selector(state, "loading");

	const handleNextClick = e => {
		e.preventDefault();
		handleSubmit(onFormTwoSubmit);
	};

	return (
		<form className="form" onSubmit={handleNextClick}>
			<div className="form__form-group">
				<div className="flex-center">
					<h3 className="account__title">Avaliação</h3>
				</div>

				<h5 className="account__sub-title text-center">
					Sua participação é importante para obtermos uma avaliação e atuarmos
					em prol do aperfeiçoamento de nossos serviços educacionais.
					<br />
					Aproveite e nos envie também as suas sugestões e/ou comentários.
					<br />
					Após a avaliação, você poderá emitir seu certificado de participação.
					<br />
					Obrigado por participar.
				</h5>
			</div>
			<div className="account__btn__group">
				<button
					type="submit"
					className="btn btn-primary account__btn account__btn--small"
					disabled={pristine || submitting}
				>
					{loading ? <Spinner type="grow" size="sm" color="dark" /> : "Iniciar"}
				</button>
			</div>
		</form>
	);
};

export default reduxForm({
	form: "certificate_emission",
	destroyOnUnmount: false, // Preserve form data
	forceUnregisterOnUnmount: true, // Unregister fields on unmount
	validate: v => validate(v, 2)
})(FormTwo);
